/**
 * Horizontal scrollable mode selector tabs for mobile
 */

import { cn } from '@frameit/ui';
import { useProjectStore, type EditorMode } from '../../stores/projectStore';

/** Editor mode configuration */
const EDITOR_MODES: { id: EditorMode; label: string; icon: string }[] = [
  {
    id: 'frame',
    label: 'Frame',
    icon: 'M4 3h16a1 1 0 011 1v16a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1zm1 2v14h14V5H5z',
  },
  { id: 'mat', label: 'Mat', icon: 'M4 4h16v16H4V4zm2 2v12h12V6H6z' },
  {
    id: 'image',
    label: 'Image',
    icon: 'M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z',
  },
  {
    id: 'paper',
    label: 'Paper',
    icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
  },
  {
    id: 'effects',
    label: 'Effects',
    icon: 'M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z',
  },
  {
    id: 'scene',
    label: 'Scene',
    icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6',
  },
  {
    id: 'gallery',
    label: 'Gallery',
    icon: 'M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z',
  },
  {
    id: 'export',
    label: 'Export',
    icon: 'M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4',
  },
];

export function MobileModeSelector() {
  const editorMode = useProjectStore((s) => s.editorMode);
  const setEditorMode = useProjectStore((s) => s.setEditorMode);

  return (
    <div className="flex overflow-x-auto border-b scrollbar-none">
      <div className="flex min-w-max px-2">
        {EDITOR_MODES.map((mode) => (
          <button
            key={mode.id}
            onClick={() => setEditorMode(mode.id)}
            className={cn(
              'flex h-12 min-w-[4.5rem] flex-col items-center justify-center gap-0.5 px-3',
              'transition-colors',
              editorMode === mode.id
                ? 'border-b-2 border-primary text-primary'
                : 'text-muted-foreground hover:text-foreground',
            )}
          >
            <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d={mode.icon} />
            </svg>
            <span className="text-xs">{mode.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
